import React from "react";
import { FeedCount, FeedCountProps } from "web/react/components/feed-count/feed-count";
import { FeedSort, FeedSortProps } from "web/react/components/feed-sort/feed-sort";
import environment from "web/script/modules/environment";
import styles from "./feed-count-and-sort.module.css";

interface FeedCountAndSortProps extends FeedCountProps, FeedSortProps {}

export function FeedCountAndSort(props: FeedCountAndSortProps): JSX.Element | null {
    return (
        <div className={styles.box}>
            <FeedCount productCount={props.productCount} retailerCount={props.retailerCount} />
            {!environment.getFeature("uf_enable_redesign_mobile_filter") && (
                <FeedSort sortOptions={props.sortOptions} />
            )}
        </div>
    );
}

export default FeedCountAndSort;
